export interface Account {
  id: string;
  name: string;
  parentId: string;
  typeEnum: number;
  levelEnum: number;
  code: string;
  children: Account[];
}

export enum AccountType {
  Asset = 1, // أصول
  Treasury = 2, // خزنة
  Bank = 3, // بنك
  Tax = 4, // ضرائب
  Other = 5, // أخرى
}

export enum AccountLevel {
  MainAccount = 1, // حساب رئيسي
  SubAccount = 2, // حساب فرعي
}

export const defaultAccount: Account = {
  id: "",
  name: "Default Name",
  parentId: null,
  typeEnum: 0,
  levelEnum: 0,
  code: "",
  children: [],
};


